import * as React from "react"
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom"
import LoginPage from "./pages/LoginPage"
import StudentRegisterPage from "./pages/StudentRegisterPage"
import ResetPasswordPage from "./pages/ResetPasswordPage"
import ProfessorDashboard from "./screens/ProfessorDashboard"
import StudentDashboard from "./screens/StudentDashboard"
import AttendanceCheckIn from "./screens/AttendanceCheckIn"
import { AuthProvider, useAuth } from "./auth/AuthContext"

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect"

function RedirectToLoginPreservingTarget() {
  const location = useLocation()
  React.useEffect(() => {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, location.pathname)
  }, [location.pathname])
  return <Navigate to="/login" replace />
}

function UnauthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/cadastro" element={<StudentRegisterPage />} />
      <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
      <Route
        path="/presenca/:token"
        element={<RedirectToLoginPreservingTarget />}
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

function AuthenticatedRoutes({ user, onLogout }) {
  const navigate = useNavigate()

  React.useEffect(() => {
    const target = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    if (target) {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
      navigate(target, { replace: true })
    }
  }, [navigate])

  const dashboard =
    user.role === "professor" ? (
      <ProfessorDashboard user={user} onLogout={onLogout} />
    ) : (
      <StudentDashboard user={user} onLogout={onLogout} />
    )

  return (
    <Routes>
      <Route path="/presenca/:token" element={<AttendanceCheckIn user={user} />} />
      <Route path="*" element={dashboard} />
    </Routes>
  )
}

function AppInner() {
  const { user, loading, logout } = useAuth()

  if (loading) {
    return (
      <div className="flex w-screen min-h-screen items-center justify-center font-oswald text-slate-200 bg-[#00072D]">
        Carregando sua sessão...
      </div>
    )
  }

  if (user) {
    return <AuthenticatedRoutes user={user} onLogout={logout} />
  }

  return <UnauthenticatedRoutes />
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppInner />
      </AuthProvider>
    </BrowserRouter>
  )
}
